const regex = /^\d{6}$/;

export default regex;